<template>
  <div>
    <v-dialog
      v-model="value"
      max-width="80%"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">Confirmación de lectura</span>
        </v-card-title>
        <v-card-text>
          <v-layout
            row
            wrap
          >
            <v-flex md4>
                  &nbsp;
            </v-flex>
            <v-flex
              xs12
              sm4
              md4
              lg4
              xl4
            >
              <v-flex class="titleSearch">
                <v-text-field
                  @input="filterSearch"
                  label="Buscar"
                  prepend-inner-icon="search"
                  solo-inverted
                  clearable
                />
              </v-flex>
            </v-flex>
            <v-flex md4>
                  &nbsp;
            </v-flex>
          </v-layout>
          <v-layout
            row
            wrap
          >
            <v-flex xs12>
              <v-data-table
                :headers="headers"
                :items="notice.watchedByParents"
                :custom-filter="customFilter"
                no-data-text="No hay tutores"
                :rows-per-page-items="[10, 15, 25]"
                rows-per-page-text="Registros por página"
                no-results-text="No hay coincidencias"
                :search="filters"
                item-key="parent.id"
                ref="table"
              >
                <template
                  v-slot:pageText="props"
                >
                  {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
                </template>
                <template
                  v-slot:headers="props"
                >
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    :style="{'width': header.width}"
                  >
                    <div>
                      <div 
                        class="d-inline-block" 
                        style="margin-left: 28px"
                      >
                        {{ header.text }}
                      </div>
                      <div 
                        class="d-inline-block circle"
                        v-if="header.tooltip"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <span
                              v-on="on"
                            >
                              ?
                            </span>
                          </template>
                          <span>{{ header.tooltip }}</span>
                        </v-tooltip>
                      </div>
                    </div>
                  </th>
                </template>
                <template v-slot:items="props">
                  <td :style="{'width': getWidth('photo')}">
                    <!-- style="width: 426px; max-width: 426px; min-width: 426px;" -->

                    <v-avatar
                      
                      :size="avatarSize"
                      color="grey lighten-4"
                      rounded
                      v-if="props.item.parent && props.item.parent.imageStorage && props.item.parent.imageStorage.miniObjUrl"
                    >
                      <img
                        :src="props.item.parent.imageStorage.miniObjUrl"
                        alt="avatar"
                      >
                    </v-avatar>
                    <v-avatar
                      v-else
                      text-color="white"
                    >
                      <v-icon>account_circle</v-icon>
                    </v-avatar>
                  </td>
                  <td 
                    class="text-xs-center" 
                    v-if="props.item.parent"
                    :style="{'width': getWidth('tutor')}"
                  >
                    {{ props.item.parent.firstName + " "+ props.item.parent.lastName }}
                  </td>
                  <td 
                    class="text-xs-center" 
                    v-if="props.item.parent"
                    :style="{'width': getWidth('mail')}"
                  >
                    {{ props.item.parent.mail }}
                  </td>
                  <td 
                    class="text-xs-center" 
                    v-if="props.item.parent"
                    :style="{'width': getWidth('statusReception')}"
                  > 
                    <v-icon
                      v-if="props.item.receivedNotice == true"
                      x-large
                      color="green darken-2"
                    >
                      task_alt
                    </v-icon>
                    <v-icon
                      v-else
                      x-large
                      color="red darken-2"
                    >
                      highlight_off
                    </v-icon>
                    <!-- <v-icon v-if="props.item.parent.parent.seeParent == true" x-large color="red darken-2">highlight_off</v-icon> -->
                  </td>
                  <td 
                    class="text-xs-center" 
                    v-if="props.item.parent"
                    :style="{'width': getWidth('statusRead')}"
                  >
                    <v-icon
                      v-if="props.item.parent.seeParent == true"
                      x-large
                      color="green darken-2"
                    >
                      task_alt
                    </v-icon>
                    <v-icon
                      v-else
                      x-large
                      color="red darken-2"
                    >
                      highlight_off
                    </v-icon>
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn flat color="primary" @click="downloadReportAll">Descargar reporte</v-btn>
          <v-btn
            flat
            color="primary"
            @click="close"
          >
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ["value", "notice"],
  data: () => ({
    avatarSize: "30px",
    filters: {
      search: ""
    },
    headers: [
      {
        text: "Foto",
        align: "center",
        value: "image",
        width: '400px',
        key: "photo",
        tooltip: ""
      },
      {
        text: "Tutor",
        align: "center",
        value: "firstName",
        width: '400px',
        key: "tutor",
        tooltip: ""
      },
      { 
        text: "Correo", 
        align: "center",
        value: "mail",
        width: '400px',
        key: 'mail',
        tooltip: ""
      },
      { 
        text: "Estatus de recepción", 
        align: "center", 
        value: "mail",
        width: '400px',
        key: 'statusReception',
        tooltip: "Indica que el tutor ya recibió el comunicado"
      },
      { 
        text: "Estatus de lectura", 
        align: "center", 
        value: "mail",
        width: '400px',
        key: 'statusRead',
        tooltip: "Indica que el tutor ya leyó el comunicado"
      }

    ]
  }),

  methods: {
     downloadReportAll() {
      this.$store
        .dispatch("reports/getConfirmParentsInfo", this.notice.id)
        .then(response => {
          var url = window.URL.createObjectURL(response.data)
          var a = document.createElement('a')
          a.href = url
          a.download = 'reporte-de-confirmacion.xlsx'
          a.click()
          a.remove()
          setTimeout(() => window.URL.revokeObjectURL(url), 100)
          // this.toast.success = true;
        })
        .catch(error => {
          // this.working.wLoading = false
          // this.toast.failed = true;
          console.log(error);
        });
    },
    getWidth(key){
      const header = this.headers.find(it => it.key === key)
      if (header){
        return header.width
      }
    },
    close() {
      this.$emit("input", !this.value);
    },
    customFilter(items, filters, filter, headers) {
      const cf = new this.$MultiFilters(items, filters, filter, headers);

      cf.registerFilter("search", function(searchWord, items) {
        if (searchWord == null) return items;

        return items.filter(item => {
          if(item.parent){
            return (
              item.parent.firstName.includes(searchWord.toLowerCase()) ||
              item.parent.lastName.includes(searchWord.toLowerCase()) ||
              item.parent.mail.includes(searchWord.toLowerCase())
            );
          }else {
            return (
              item.firstName.includes(searchWord.toLowerCase()) ||
              item.lastName.includes(searchWord.toLowerCase()) ||
              item.mail.includes(searchWord.toLowerCase())
            );
          }
          
        }, searchWord);
      });
      return cf.runFilters();
    },
    filterSearch(val) {
      this.filters = this.$MultiFilters.updateFilters(this.filters, {
        search: val
      });
    }
  },
  mounted() {
    console.log(this.notice.watchedByParents);
  },
};
</script>
<style>
.titleSearch .v-input .v-text-field .v-input__slot {
  border-radius: 33px !important;
}
</style>
<style scoped>

.circle{
  background-color: gray;
  width: 18px !important;
  height: 18px !important;
  border-radius: 50% !important;
  color: white;
  text-align: center;
  margin-left: 10px;
}
.titleSearch .v-input .v-text-field .v-input__slot {
  border-radius: 33px !important;
}
</style>